var _defs, _path, _polygon, _text, _text2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1853.33 513.27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#003d24;}.cls-2{font-size:241.91px;font-family:Petrona-SemiBold, Petrona;font-weight:600;letter-spacing:-0.06em;}.cls-2,.cls-4{fill:#231f20;}.cls-3{letter-spacing:-0.05em;}.cls-4{font-size:109.09px;font-family:HostGrotesk-Medium, Host Grotesk;font-weight:500;}.cls-5{letter-spacing:-0.06em;}.cls-6{letter-spacing:-0.12em;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M256.63,513.27C115.13,513.27,0,398.14,0,256.63S115.13,0,256.63,0,513.27,115.13,513.27,256.63,398.14,513.27,256.63,513.27Zm0-496.17C124.55,17.1,17.1,124.55,17.1,256.63S124.55,496.16,256.63,496.16,496.16,388.71,496.16,256.63,388.71,17.1,256.63,17.1Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "423.15 306.17 427.6 311.81 256.39 457.11 245.44 457.11 74.15 311.81 78.59 306.17 238.69 420.76 239.63 383.65 46.01 221.25 50.46 215.6 240.4 353.21 241.51 304.46 74.15 162.5 78.59 156.77 242.28 274.01 243.39 230.66 123.66 125.72 128.11 120.08 244.07 200.3 246.98 83.31 254.85 83.31 257.67 200.3 373.63 120.08 378.08 125.72 258.44 230.66 259.47 274.01 423.15 156.77 427.6 162.5 260.24 304.46 261.43 353.21 451.29 215.6 455.73 221.25 262.2 383.65 263.06 420.76 423.15 306.17"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(573.88 295.73)"
  }, "O", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-3",
    x: 161.84,
    y: 0
  }, "scar Global "))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(592.9 432.12)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-5"
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    x: 57.93,
    y: 0
  }, "OURS &amp; TR"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-6",
    x: 624,
    y: 0
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    x: 684.88,
    y: 0
  }, "VEL"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.12930b64287b7e9f792e9072affec755.svg";
export { ForwardRef as ReactComponent };